import UserPermissions from './UserPermissions';

export default UserPermissions;
